module.exports = __webpack_public_path__ + "img/ccwl-2.138cd572.png";